<script>
import options from './StafetDonationTaendLysStepOne.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-donation-step-one kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.yourSupportSelectorDropdownLabel }}
    </h2>

    <SupportSelector
      :stafetId="stafetId"
      :labels="labels"
      :displayInputError="displayInputError"
      :onChangeCallback="updateSupportSelector"
      :holdList="holdList"
    />

    <h2 class="kb-stafet-step__title">
      {{ labels.taendEtLysTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <FormInputTextField
        :modelValue="donationAmount.toString()"
        v-model="donationAmount"
        :isRequired="true"
        fieldName="donationAmount"
        :label="labels.taendEtLysSelectQuantityLabel"
        type="number"
        :isValidationError="showDonationAmoutErrorMessage"
        :placeholder="labels.taendEtLysSelectQuantityLabel"
        :errorMessageLabel="labels.taendEtLysSelectQuantityErrorMessage"
      />

      <FormInputTextField
        :modelValue="amount.toString()"
        v-model="amount"
        :label="labels.taendEtLysSelectAmountLabel"
        :isRequired="true"
        fieldName="amount"
        type="number"
        :isValidationError="showDonationPerLightBagErrorMessage"
        :placeholder="labels.taendEtLysSelectAmountPlaceholder"
        :errorMessageLabel="labels.taendEtLysSelectAmountErrorMessage"
        :onChangeCallback="(e) => setDonationPerLightBag(e.target.value)"
      />
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep1"
    />
  </article>
</template>
